export const base = 'persona';

export const getAllPersonas = `${base}`;
export const getTopPersonas = `${base}/top-personas`;
export const getPersonaById = `${base}`;
export const postRenamePersona = `${base}/rename-persona`;
